// Canonical, non-www domain for all SEO output.
export const SITE_URL = "https://milliondollarshot.org";
export const OG_IMAGE = `${SITE_URL}/brand/og-home.png`;

// Each route renders the full single-page site (visual experience unchanged) but
// carries its own title, description, canonical, Open Graph/Twitter tags and
// breadcrumb structured data, and scrolls to its section on load.
export const PAGES = {
  home: {
    key: "home",
    path: "/",
    section: "top",
    label: "Home",
    title: "Million Dollar Shot | Fort Myers Gala",
    description:
      "Join us beneath the stars for the inaugural Million Dollar Shot Fort Myers Gala benefiting Naples Cancer Advisors on November 14, 2026. Experience an unforgettable evening featuring luxury dining, live entertainment, and the opportunity for six guests to take the Million Dollar Shot.",
  },
  "the-evening": {
    key: "the-evening",
    path: "/the-evening",
    section: "event",
    label: "The Evening",
    title: "The Evening | Million Dollar Shot",
    description:
      "Explore the unforgettable evening of Million Dollar Shot, from the red carpet arrival and luxury marketplace to the chef-curated dinner and Million Dollar Shot finale.",
  },
  champions: {
    key: "champions",
    path: "/champions",
    section: "fundraising",
    label: "Champions",
    title: "Champions | Million Dollar Shot",
    description:
      "Meet the distinguished community leaders selected as Champions for the inaugural Million Dollar Shot.",
  },
  sponsors: {
    key: "sponsors",
    path: "/sponsors",
    section: "sponsors",
    label: "Sponsors",
    title: "Sponsors | Million Dollar Shot",
    description:
      "Recognize the generous sponsors whose support makes Million Dollar Shot possible.",
  },
  committee: {
    key: "committee",
    path: "/committee",
    section: "committee",
    label: "Committee",
    title: "Committee | Million Dollar Shot",
    description:
      "Meet the dedicated planning committee behind the inaugural Million Dollar Shot gala.",
  },
  "why-we-gather": {
    key: "why-we-gather",
    path: "/why-we-gather",
    section: "about",
    label: "Why We Gather",
    title: "Why We Gather | Million Dollar Shot",
    description:
      "Learn how Naples Cancer Advisors changes lives through no-cost expert cancer guidance for patients across Southwest Florida.",
  },
};

// Ordered list of the primary navigation pages (excludes home).
export const NAV_PAGES = [
  "the-evening",
  "champions",
  "sponsors",
  "committee",
  "why-we-gather",
];

export const pathToKey = (pathname) => {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  if (p === "/") return "home";
  const key = p.slice(1);
  return PAGES[key] ? key : "home";
};
